<template>
  <form class="w-full" role="search" @submit.prevent="onSearch">
    <div class="search-bar__wrapper flex items-center gap-xs">
      <div class="search-bar__field">
        <avtalat-input
          id="search-number-box"
          v-model:value="state.searchText"
          label="Sök personnummer, organisationsnummer eller ärende-id"
          :labelHidden="true"
          icon="forstoringsglas"
          placeholder="Sök personnummer, organisationsnummer eller ärende-id"
          :validationStatus="state.validationStatus"
          :errorMessage="state.errorMessage"
          @keyup="onKeyUp($event)"
        />
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { onMounted, reactive, watch } from "vue";

import { useNavigation } from "@/composables/useNavigation";
import { isValidSearchTerm } from "@/common/validators";

const navigation = useNavigation();
const state = reactive<{
  searchText: string;
  isValidNumber: boolean;
  validationStatus: string;
  errorMessage: string;
}>({
  searchText: pnrBeforeOrgnr() as string,
  isValidNumber: false,
  validationStatus: "",
  errorMessage: "",
});

const emits = defineEmits<{ (e: "searchTextChange", value?: string): void }>();

const props = defineProps({
  errorMessage: String,
});

function orgnrBeforeQuery() {
  return navigation.currentRoute.query.organisationsnummer
    ? navigation.currentRoute.query.organisationsnummer
    : navigation.currentRoute.query.q;
}

function pnrBeforeOrgnr() {
  return navigation.currentRoute.query.personnummer
    ? navigation.currentRoute.query.personnummer
    : orgnrBeforeQuery();
}
watch(
  () => props.errorMessage,
  () => {
    validateNumber();
  },
);
function validateNumber() {
  state.isValidNumber = isValidSearchTerm(state.searchText);
  state.validationStatus =
    state.isValidNumber && !props.errorMessage ? "valid" : "invalid";

  state.errorMessage =
    props.errorMessage ??
    (state.isValidNumber
      ? ""
      : "Ej korrekt personnummer, organisationsnummer eller ärende-id");
}

function onSearch() {
  validateNumber();

  if (state.isValidNumber) {
    navigation.search(state.searchText);
  }
}

function resetValidation(e: KeyboardEvent) {
  if (e.key !== "Enter") {
    state.isValidNumber = isValidSearchTerm(state.searchText);
    state.validationStatus = "";
    state.errorMessage = "";
  }
}

const onKeyUp = (e: KeyboardEvent) => {
  resetValidation(e);
  emits("searchTextChange", state.searchText);
};

onMounted(() => {
  if (state.searchText?.length) validateNumber();
});
</script>

<style>
.search-bar__wrapper {
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.search_bar__field-input {
  width: 100%;
}

.search-bar__field {
  flex-grow: 1;
  z-index: 1;
}

.search-bar__field span:first-of-type {
  color: var(--text-text-default);
}

.search-bar__search-button-wrapper {
  display: flex;
  justify-content: center;
}
</style>
